/* @flow */
import * as React from 'react';

type Generator = Object => React.Node;

export function composeMultipleCells(generators: Generator[]): Generator {
  return (input: Object) => {
    return (
      <React.Fragment>
        {generators.map((generator, index) => (
          <React.Fragment key={index}>{generator(input)}</React.Fragment>
        ))}
      </React.Fragment>
    );
  };
}
